const TEMPLATE_PATH = `${process.env.PUBLIC_URL}/templates/template-file-gara.xlsx`;
const TEMPLATE_FILENAME = "template-file-gara.xlsx";

/** Download the standard gara Excel template (header row only). */
export function downloadGaraTemplate(): void {
  const link = document.createElement("a");
  link.href = TEMPLATE_PATH;
  link.download = TEMPLATE_FILENAME;
  link.click();
}
